import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShortcut"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8 13H11.667L11 17L16 11H12.333L13 7L8 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShortcut;
